export default "__VITE_ASSET__A6iig8tH__"